import { getCurrentAnnouncement } from '@ms/yammer-data/dist/domains/announcements/selectors';

import { useSelector } from '../useSelector';

type UseCurrentAnnouncement = () => ReturnType<typeof getCurrentAnnouncement>;
export const useCurrentAnnouncement: UseCurrentAnnouncement = () => useSelector(getCurrentAnnouncement);
